import React, { useEffect,useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaWarehouse } from "react-icons/fa";
import { BsBoxSeam } from "react-icons/bs";
import { MdListAlt } from "react-icons/md";
import { MdQrCodeScanner } from "react-icons/md";
import { BsTruck } from "react-icons/bs";
import { BsHouseDoorFill } from "react-icons/bs";
import { FcCollapse } from "react-icons/fc";
import { FcExpand } from "react-icons/fc";
import {RiArrowUpSLine,RiArrowDownSLine} from "react-icons/ri"
import { MdHouse } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { setwarehousemainSection, setUserPermissions } from "../../redux/slices/user/userSlice";
// const mainSection = [
//   {
//     title: "Goods in/out",
//     path: "/dashboard/warehouse/goodsInout",
//     exact: true,
//     icon: (
//       <svg
//         width="18"
//         height="18"
//         viewBox="0 0 18 18"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           fill-rule="evenodd"
//           clip-rule="evenodd"
//           d="M17.2508 4.5495V13.5983L9 18L0.75 13.5983V4.5L9 0L17.2508 4.5495ZM1.5 13.1483L8.625 16.95V9.0225L1.5 5.313V13.1483ZM16.5008 5.35725L9.375 9.024V16.95L16.5008 13.1483V5.35725ZM12.3608 6.64425L5.21025 2.92125L1.9485 4.701L9.0015 8.373L12.3608 6.64425ZM6.00375 2.4885L13.1775 6.2235L16.0515 4.7445L8.99775 0.85575L6.00375 2.4885Z"
//           fill="white"
//         />
//       </svg>
//     ),
//   },
//   {
//     title: "Inventory",
//     path: "/production/schedule",
//     exact: true,
//     icon: (
//       <svg
//         width="16"
//         height="18"
//         viewBox="0 0 16 18"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           fill-rule="evenodd"
//           clip-rule="evenodd"
//           d="M4.25 18H0.5V11.25H4.25V12.5513C4.7285 12.4028 5.2415 12.18 5.57375 12.0345C6.05525 11.8245 6.518 11.7218 6.989 11.7218C7.8995 11.7218 8.64275 12.096 10.2163 12.6255C10.6963 12.786 11.0233 13.1625 11.0975 13.605C11.9405 12.9577 13.2875 11.9122 13.3003 11.9025C13.568 11.6895 13.88 11.577 14.2003 11.577C14.9143 11.577 15.5135 12.1492 15.5135 12.858C15.5135 13.2255 15.3493 13.5907 15.0433 13.875C14.0098 14.835 13.2095 15.5497 12.503 16.1805C12.083 16.5562 11.7035 16.8945 11.342 17.2253C10.7803 17.7405 10.2035 17.9797 9.52625 17.9797C9.2225 17.9797 8.90225 17.931 8.54525 17.8298C6.4655 17.2425 5.18225 17.0527 4.25 17.001V18ZM3.5 12H1.25V17.25H3.5V12ZM4.25 16.248C5.819 16.3365 7.55375 16.77 8.74925 17.1082C9.362 17.2815 10.07 17.3737 10.8358 16.6725C11.795 15.7935 12.8773 14.8628 14.5325 13.3253C15.1505 12.7515 14.399 11.988 13.766 12.4905C13.766 12.4905 11.5453 14.2147 10.9993 14.6227C10.715 14.8365 10.478 15.012 10.1383 15.012C10.058 15.012 9.971 15.0023 9.8765 14.9805C9.38525 14.8673 8.46425 14.6618 7.81025 14.4548C7.379 14.3175 7.532 13.71 8.01125 13.8113C8.3465 13.881 9.20675 14.0737 9.662 14.2013C10.4248 14.412 10.619 13.551 9.9785 13.3373C9.557 13.1948 9.57575 13.1888 8.56175 12.8385C7.586 12.5002 6.90125 12.2738 5.873 12.7215C5.39375 12.93 4.799 13.1835 4.25 13.332V16.248ZM7.0925 1.31325L9.5 0L14.75 2.895V8.65275L9.5 11.454L4.25 8.65275V2.8635L7.088 1.3155L7.0895 1.31175L7.0925 1.31325ZM9.125 5.8245L5 3.6765V8.20275L9.125 10.404V5.8245ZM9.875 5.82525V10.404L14 8.20275V3.70275L9.875 5.82525ZM11.2025 4.299L7.1 2.163L5.4485 3.0645L9.5015 5.17425L11.2025 4.299ZM7.8935 1.73025L12.0192 3.87825L13.5508 3.09L9.49775 0.85575L7.8935 1.73025Z"
//           fill="white"
//         />
//       </svg>
//     ),
//   },
//   {
//     title: "Scan/print barcode",
//     path: "/dashboard/warehouse/printscan",
//     exact: true,
//     icon: (
//       <svg
//         width="18"
//         height="18"
//         viewBox="0 0 18 18"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M7.332 1.5L15.879 10.0463L10.044 15.879L1.5 7.33575V1.5H7.332ZM7.95375 0H0V7.95675L10.0433 18L18 10.047L7.95375 0ZM5.5605 5.5605C4.97475 6.147 4.026 6.147 3.43875 5.56125C2.853 4.974 2.853 4.02525 3.43875 3.4395C4.02525 2.853 4.97475 2.85375 5.5605 3.43875C6.147 4.026 6.14625 4.974 5.5605 5.5605ZM5.0145 8.19675L8.19675 5.0145L8.727 5.54475L5.54475 8.727L5.0145 8.19675ZM6.075 9.25725L9.25725 6.075L9.52275 6.3405L6.3405 9.52275L6.075 9.25725ZM8.19675 11.379L11.379 8.19675L11.6445 8.46225L8.46225 11.6445L8.19675 11.379ZM6.87075 10.053L10.053 6.87075L10.8488 7.6665L7.6665 10.8488L6.87075 10.053ZM8.99175 12.174L12.174 8.99175L12.7042 9.522L9.522 12.7042L8.99175 12.174ZM10.053 13.2345L13.2345 10.053L13.5 10.3185L10.3185 13.5L10.053 13.2345Z"
//           fill="white"
//         />
//       </svg>
//     ),
//   },
//   {
//     title: "Supplier",
//     path: "/production/schedule",
//     exact: true,
//     icon: (
//       <svg
//         width="18"
//         height="14"
//         viewBox="0 0 18 14"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           fill-rule="evenodd"
//           clip-rule="evenodd"
//           d="M3.75 6.25V7H9.75V1.75H2.25V1C2.25 0.586 2.586 0.25 3 0.25H10.5C10.914 0.25 11.25 0.586 11.25 1V2.5H14.7502C15.588 2.5 15.9503 2.932 16.2023 3.33025C16.6478 4.03525 17.3542 5.15425 17.784 5.86375C17.925 6.09775 18 6.36625 18 6.64V10C18 10.8167 17.4427 11.5 16.5 11.5H15.75C15.75 12.742 14.742 13.75 13.5 13.75C12.258 13.75 11.25 12.742 11.25 11.5H8.25C8.25 12.742 7.242 13.75 6 13.75C4.758 13.75 3.75 12.742 3.75 11.5H3C2.586 11.5 2.25 11.164 2.25 10.75V6.25H0.75V4.75H6V6.25H3.75ZM6 10.6C6.4965 10.6 6.9 11.0035 6.9 11.5C6.9 11.9965 6.4965 12.4 6 12.4C5.5035 12.4 5.1 11.9965 5.1 11.5C5.1 11.0035 5.5035 10.6 6 10.6ZM13.5 10.6C13.9965 10.6 14.4 11.0035 14.4 11.5C14.4 11.9965 13.9965 12.4 13.5 12.4C13.0035 12.4 12.6 11.9965 12.6 11.5C12.6 11.0035 13.0035 10.6 13.5 10.6ZM11.25 8.5H3.75V10H4.32375C4.7355 9.5395 5.334 9.25 6 9.25C6.666 9.25 7.2645 9.5395 7.67625 10H11.8238C12.2355 9.5395 12.834 9.25 13.5 9.25C14.166 9.25 14.7645 9.5395 15.1763 10H16.5V6.56875L15.2167 4.372C15.0825 4.14175 14.8358 4 14.5695 4H11.25V8.5ZM12 4.75V7H15.75L14.6798 5.128C14.5463 4.894 14.298 4.75 14.0287 4.75H12ZM0 2.5H6V4H0V2.5Z"
//           fill="white"
//         />
//       </svg>
//     ),
//   },
//   {
//     title: "Warehouses",
//     path: "/dashboard/warehouse/warehouse-list",
//     exact: true,
//     icon: <FaWarehouse size="1.2rem" color="#FFFFFF" />,
//   },
// ];
type propss = {
  showSideBar: Boolean;
};
export default function WarehouseListItem(props: propss) {
  const navigate = useNavigate();
  const [collaps, setcollaps] = React.useState(true);
  // const Permissions = JSON.parse(localStorage.getItem("Permissions")!);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const Permissions = useSelector((state) => state.user.userPermissions);
  const viewbarcode = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_barcode"): []
  const viewsupplier = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_supplier"): []
  const viewwarehouse = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_warehouse"): []
  const viewgoodsinout = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_goodsinout"):[]


  const dispatch = useDispatch();

  const mainSection = useSelector((state) => state.user.warehousemainSection);

  const updateState = () => {
    const newState = mainSection.map((obj) => {
      if (viewsupplier === undefined && obj.title === "Supplier") {
        return { ...obj, permission: false };
      }
      if (viewwarehouse === undefined && obj.title === "Warehouses") {
        return { ...obj, permission: false };
      }
      if (viewbarcode === undefined && obj.title === "Scan/print barcode") {
        return { ...obj, permission: false };
      }
      if (viewgoodsinout === undefined && obj.title === "Goods in/out") {
        return { ...obj, permission: false };
      }
      // 👇️ otherwise return object as is
      return obj;
    });
    console.log("newstate warehouse......", newState);
    setIsInitialRender(false);
    dispatch(setwarehousemainSection(newState));
  };

  useEffect(() => {
    if (isInitialRender) {
    updateState();
    console.log("Permissions Updated warehouse");
    }
  }, [viewsupplier,viewwarehouse,viewbarcode, viewgoodsinout,isInitialRender]);

  const handlecollaps = () => {
    setcollaps(!collaps);
  };
  const handleRoute = () => {
    navigate("/production/schedule");
  };

  return (
    <>
      {props.showSideBar ? (
        <div>
          <div className="flex  px-2 mt-4 ">
            <div className="w-full">
              <div className="flex justify-between w-full items-center">
                <Link
                  to="/"
                  className="flex justify-start items-center align-middle"
                >
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.25 11.0391V20.2057H13.75V14.7057H8.25V20.2057H2.75V11.0391H0L11 0.0390625L22 11.0391H19.25ZM18.3333 5.62431V0.955729H15.5833V2.87431L18.3333 5.62431Z"
                      fill="white"
                    />
                  </svg>

                  <h2 className="px-2 py-2 text-white font-Roboto">
                    Warehouse
                  </h2>
                </Link>
                <button onClick={handlecollaps}>
                  {collaps ? (
                    <RiArrowUpSLine color="#FFFFFF" size={20} fill="white" />
                  ) : (
                    <RiArrowDownSLine color="#FFFFFF" size={20} fill="white" />
                  )}
                </button>
              </div>
            </div>
          </div>
          {collaps && (
            <ul className="ml-6 mr-6">
              {mainSection.map((item) => (
                 item.permission === true ? (
                <li className="p-1  rounded-md">
                  <Link to={item.path}>
                    <div className="flex justify-start items-center align-middle hover:bg-blue-100 rounded-md pl-2">
                      {item.icon}
                      <h2 className="px-2 py-2 text-white font-Roboto">
                        {item.title}
                      </h2>
                    </div>
                  </Link>
                </li>
                ):null 
              ))}
            </ul>
          )}
        </div>
      ) : (
        <div className="pt-6">
          <div className="flex flex-col items-center px-2  ">
            <button
              className="flex justify-between w-full items-center"
              onClick={handlecollaps}
            >
              <MdHouse size="2rem" color="#FFFFFF" />
            </button>
          </div>
          {collaps && (
            <ul className="flex flex-col items-center py-2">
              {mainSection.map((item) => (
                item.permission === true ?(  
                <li className="p-1 rounded-md py-2 hover:bg-blue-100">
                  <Link to={item.path}>{item.icon}</Link>
                </li>
                ): null
              ))}
            </ul>
          )}
        </div>
      )}
    </>
  );
}
